import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { throttle } from 'lodash';
import { KEY_CODES } from '../../../widget/constants/key-codes';
export class KeyboardNavigation extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleKeydown", void 0);
    _defineProperty(this, "_handleKeydown", event => {
      if (event.keyCode === KEY_CODES.LEFT) {
        this.props.onKeyboardArrowLeft();
      }
      if (event.keyCode === KEY_CODES.RIGHT) {
        this.props.onKeyboardArrowRight();
      }
    });
    this.handleKeydown = throttle(this._handleKeydown, props.throttle);
  }
  componentDidMount() {
    document.body.addEventListener('keydown', this.handleKeydown);
  }
  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.handleKeydown);
    this.handleKeydown.cancel();
  }
  render() {
    return null;
  }
}
_defineProperty(KeyboardNavigation, "defaultProps", {
  throttle: 200
});
//# sourceMappingURL=keyboard-navigation.js.map